import React, { useState } from 'react';
import './SOPLayout.css';
import { 
  Dashboard as DashboardIcon, 
  Folder as ProjectIcon, 
  CheckCircle as TaskIcon, 
  AccessTime as TimeIcon, 
  Message as MessageIcon, 
  LibraryBooks as LibraryIcon, 
  Group as TeamIcon,
  Search as SearchIcon,
  Notifications as NotifIcon,
  Add as AddIcon,
  Description as FileIcon
} from '@mui/icons-material';

const SOPLibrary = () => {
  const [activeTab, setActiveTab] = useState('SOP Library');

  const navItems = [
    { name: 'Dashboard', icon: <DashboardIcon /> },
    { name: 'Projects', icon: <ProjectIcon /> },
    { name: 'Tasks', icon: <TaskIcon /> },
    { name: 'Time Tracking', icon: <TimeIcon /> },
    { name: 'Messages', icon: <MessageIcon /> },
    { name: 'SOP Library', icon: <LibraryIcon />, active: true },
    { name: 'Team', icon: <TeamIcon /> },
  ];

  const articles = [
    {
      id: 1,
      category: 'BIM Coordination',
      title: 'Company standard for electrical Revit families',
      description: 'Company standard for electrical Revit families. Version 1.0. Scope: creation, parameterization, and classification of all electrical elements.',
      author: 'a.gromkova',
      readTime: '4 min read',
      updated: 'Updated 2 days ago'
    },
    {
      id: 2,
      category: 'Company Standards',
      title: 'Clash Detection Strategy and Ruleset Documentation',
      description: 'Clash Detection Strategy and Ruleset Documentation. Software: Navisworks Manage 2024. BIM coordinator role when resolving clashes.',
      author: 'a.gromkova',
      readTime: '8 min read',
      updated: 'Updated 2 days ago'
    },
    {
      id: 3,
      category: 'Company Standards',
      title: 'BIM Modeling Standards – Modeling guide',
      description: 'BIM Modeling Standards – Modeling guide. General requirements for Revit models. All models use a single coordinate system.',
      author: 'a.gromkova',
      readTime: '19 min read',
      updated: 'Updated 2 days ago'
    }
  ];

  return (
    <div className="sop-container">
      {/* Sidebar */}
      <aside className="sop-sidebar">
        <div className="sop-brand">
          <div className="sop-brand-logo">A</div>
          <div>
            Alement
            <span style={{ display: 'block', fontSize: '11px', color: '#64748b', fontWeight: 400 }}>Project Manager</span>
          </div>
        </div>

        <nav>
          {navItems.map((item) => (
            <div 
              key={item.name} 
              className={`sop-nav-item ${item.active ? 'active' : ''}`}
            >
              {item.icon}
              {item.name}
            </div>
          ))}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="sop-main">
        {/* Header */}
        <header className="sop-header">
          <div className="sop-header-title">
            <h1>SOP Library</h1>
            <span>Standard Operating Procedures</span>
          </div>

          <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <div className="sop-search">
              <SearchIcon sx={{ color: '#64748b' }} />
              <input type="text" placeholder="Search projects, tasks..." />
            </div>
            
            <NotifIcon sx={{ color: '#94a3b8', cursor: 'pointer' }} />
            
            <button className="sop-btn-primary">
              <AddIcon sx={{ fontSize: 18, marginRight: '5px' }} />
              New Article
            </button>
          </div>
        </header>

        {/* Content Body */}
        <div className="sop-content">
          <div style={{ display: 'flex', gap: '16px', marginBottom: '32px' }}>
            <div className="sop-search" style={{ width: '100%', maxWidth: '400px' }}>
              <SearchIcon sx={{ color: '#64748b' }} />
              <input type="text" placeholder="Search articles..." />
            </div>
          </div>

          <div className="sop-section-title">
            <FileIcon sx={{ fontSize: 16, marginRight: '8px', verticalAlign: 'text-bottom' }} />
            3 Articles
          </div>

          <div className="sop-grid">
            {articles.map(article => (
              <div key={article.id} className="sop-card">
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                  <div className="sop-card-icon">
                    <FileIcon />
                  </div>
                  <div>
                    <span className="sop-card-tag">{article.category}</span>
                    <h3 className="sop-card-title">{article.title}</h3>
                    <p className="sop-card-desc">{article.description}</p>
                    
                    <div className="sop-card-meta">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                         <div className="sop-avatar"></div>
                         {article.author}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <TimeIcon sx={{ fontSize: 14 }} />
                        {article.readTime}
                      </div>
                      <div>{article.updated}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default SOPLibrary;
